module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    attrs: {
      "label": _vm.label,
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "align-top": "",
        "pa-1": ""
      }
    }, [_c('v-radio', {
      staticClass: "shrink mr-2",
      attrs: {
        "name": "active",
        "value": item[_vm.itemValue] || Object.values(item)[0]
      }
    }), _vm._v(" "), _c(_vm.createComp(item[_vm.itemText] || Object.values(item)[0]), {
      tag: "component"
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b51c76da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SelectRadio.vue
// module id = 813
// module chunks = 1